import { useLayoutEffect } from "react";
import Text from "consumer/custom/text";


export default function Address() {

    useLayoutEffect(() => {
        daum_address_setup()
    }, [])

    async function daum_address_setup() {
        const script = document.createElement('script')
        script.src = "//t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js"
        document.head.append(script)
    }

    function foldDaumPostcode() {
        const element_wrap = document.getElementById('wrap');
        element_wrap.style.display = 'none';
    }

    function sample3_execDaumPostcode() {
        const element_wrap = document.getElementById('wrap');
        // 현재 scroll 위치를 저장해놓는다.
        var currentScroll = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
        new window.kakao.Postcode({
            oncomplete: function(data) {
                let addr = '';
                if(data.userSelectedType === 'R') {
                    addr = data.roadAddress;
                }
                else {
                    addr = data.jibunAddress;
                }

                document.getElementById("address").value = addr;

                // iframe을 넣은 element를 안보이게 한다.
                // (autoClose:false 기능을 이용한다면, 아래 코드를 제거해야 화면에서 사라지지 않는다.)
                element_wrap.style.display = 'none';

                // 우편번호 찾기 화면이 보이기 이전으로 scroll 위치를 되돌린다.
                document.body.scrollTop = currentScroll;
            },
            // 우편번호 찾기 화면 크기가 조정되었을때 실행할 코드를 작성하는 부분. iframe을 넣은 element의 높이값을 조정한다.
            onresize : function(size) {
                element_wrap.style.height = size.height+'px';
            },
            width : '100%',
            height : '100%'
        }).embed(element_wrap)

        // iframe을 넣은 element를 보이게 한다.
        element_wrap.style.display = 'block';
    }

    return(
        <div
            style={{
                width: "100%"
            }}
        >
            <Text
                label="주소"
                id="address"
                name="address"
                read={true}
                event={{
                    onClick: function(e) {
                        sample3_execDaumPostcode()
                    }
                }}
            ></Text>

            <div
                id="wrap"
                style={{
                    display: "none",
                    border: "1px solid",
                    width: "100%",
                    height: "300px",
                    margin: "5px 0",
                    position: "relative",
                    flexShrink: 0,
                    overflowY: "auto"
                }}
            >
                <img
                    src="//t1.kakaocdn.net/postcode/resource/images/close.png"
                    id="btnFoldWrap"
                    style={{
                        position: "absolute",
                        right: "0px",
                        top: "-1px",
                        zIndex: 1,
                        cursor: "pointer"
                    }}
                    onClick={() => foldDaumPostcode()}
                    alt="접기 버튼"
                ></img>
            </div>
        </div>
    )
}